<template>
  <section class="content">
    <div>
     <b-alert variant="danger"
            dismissible
            :show="showDismissibleAlert"
            @dismissed="showDismissibleAlert=false">
     {{messageAlert}}
   </b-alert>
   </div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header" v-if="exibirGrafico">
            <va-chart
                :chart-config='acumuladosGrafico'></va-chart>
          </div>
        </div>
      </div>
      <!-- /.box-header -->
    </div>
    <div class="row center-block">
      <div class="col-md-12" >
        <div class="box box-info">
          <div class="box-header col-md-12" v-if="idioma === 'DE'">
            <h3>Anforderungen an die Suche</h3>
            <br>
            <h4>Zeitverlauf</h4>
            <div class="form-group col-sm-12">
              <label for="dataInicioBusca" class="col-sm-2 control-label">Anfangsdatum</label>
              <div class="col-sm-4"> 
                <datepicker :language="de" placeholder="Startdatum auswählen" v-model="dataInicioBusca" id="dataInicioBusca"></datepicker>
              </div>
              <label for="dataFimBusca" class="col-sm-2 control-label">Letzter Termin</label>
              <div class="col-sm-4">
                <datepicker :language="de" placeholder="Enddatum auswählen" v-model="dataFimBusca" id="dataFimBusca"></datepicker>
              </div>
            </div>
          </div>
          <div class="box-header col-md-12"  v-else-if="idioma === 'EN'">
            <h3>Search requirements</h3>
            <br>
            <h4>Time course</h4>
            <div class="form-group col-sm-12">
              <label for="dataInicioBusca" class="col-sm-2 control-label">Initial date</label>
              <div class="col-sm-4"> 
                <datepicker :language="en" placeholder="Select start date" v-model="dataInicioBusca" id="dataInicioBusca"></datepicker>
              </div>
              <label for="dataFimBusca" class="col-sm-2 control-label">Final date</label>
              <div class="col-sm-4">
                <datepicker :language="en" placeholder="Select end date" v-model="dataFimBusca" id="dataFimBusca"></datepicker>
              </div>
            </div>
          </div>
          <div class="box-header col-md-12"  v-else-if="idioma === 'ES'">
            <h3>Requisitos de búsqueda</h3>
            <br>
            <h4>Curso del tiempo</h4>
            <div class="form-group col-sm-12">
              <label for="dataInicioBusca" class="col-sm-2 control-label">La fecha de inicio</label>
              <div class="col-sm-4"> 
                <datepicker :language="es" placeholder="Seleccionar fecha de inicio" v-model="dataInicioBusca" id="dataInicioBusca"></datepicker>
              </div>
              <label for="dataFimBusca" class="col-sm-2 control-label">Fecha final</label>
              <div class="col-sm-4">
                <datepicker :language="es" placeholder="Seleccionar fecha de finalización" v-model="dataFimBusca" id="dataFimBusca"></datepicker>
              </div>
            </div>
          </div>
          <div class="box-header col-md-12" v-else>
            <h3>Requisitos de pesquisa</h3>
            <br>
            <h4>Período</h4>
            <div class="form-group col-sm-12">
              <label for="dataInicioBusca" class="col-sm-2 control-label">Data Inicial</label>
              <div class="col-sm-4"> 
                <datepicker :language="ptBR" placeholder="Selecione a data inicial" v-model="dataInicioBusca" id="dataInicioBusca"></datepicker>
              </div>
              <label for="dataFimBusca" class="col-sm-2 control-label">Data Final</label>
              <div class="col-sm-4">
                <datepicker :language="ptBR" placeholder="Selecione a data final" v-model="dataFimBusca" id="dataFimBusca"></datepicker>
              </div>
            </div>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="input-group" v-if="idioma === 'DE'">
              <h4>Parameter</h4>
              <div class="form-group">
                <select class="form-control" id="parametro" v-model="parametro" >
                  <option value="">Parameter auswählen</option>
                  <option :value="[registro['.key'],registro.labelDe,registro.unidade_medida]" v-for="(registro, key) in orderBy(filterBy(filterBy(registros, true, 'registrado'), true, 'is_acumulador'), 'labelDe')" :key="key">{{registro.labelDe}}</option>
                </select>
              </div>
              <br />
            </div>
            <div class="input-group" v-else-if="idioma === 'EN'">
              <h4>Parameter</h4>
              <div class="form-group">
                <select class="form-control" id="parametro" v-model="parametro" >
                  <option value="">Select Parameter</option>
                  <option :value="[registro['.key'],registro.labelEn,registro.unidade_medida]" v-for="(registro, key) in orderBy(filterBy(filterBy(registros, true, 'registrado'), true, 'is_acumulador'), 'labelEn')" :key="key">{{registro.labelEn}}</option>
                </select>
              </div>
              <br />
            </div>
            <div class="input-group" v-else-if="idioma === 'ES'">
              <h4>Parámetro</h4>
              <div class="form-group">
                <select class="form-control" id="parametro" v-model="parametro" >
                  <option value="">Seleccionar parámetro</option>
                  <option :value="[registro['.key'],registro.labelEs,registro.unidade_medida]" v-for="(registro, key) in orderBy(filterBy(filterBy(registros, true, 'registrado'), true, 'is_acumulador'), 'labelEs')" :key="key">{{registro.labelEs}}</option>
                </select>
              </div>
              <br />
            </div>
            <div class="input-group" v-else>
              <h4>Parâmetro</h4>
              <div class="form-group">
                <select class="form-control" id="parametro" v-model="parametro" >
                  <option value="">Selecione o Parâmetro</option>
                  <option :value="[registro['.key'],registro.labelPtBr,registro.unidade_medida]" v-for="(registro, key) in orderBy(filterBy(filterBy(registros, true, 'registrado'), true, 'is_acumulador'), 'labelPtBr')" :key="key">{{registro.labelPtBr}}</option>
                </select>
              </div>
              <br />
            </div>
          </div>
          <div class="box-footer">
            <div class="col-sm-2" v>
              <button type="button" v-on:click="efetuarPesquisa()" class="btn btn-primary">
                Efetuar Pesquisa
              </button>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
    </div>  
  </section>
</template>

<script>
// import VueTimepicker from 'vue2-timepicker'
import Datepicker from 'vuejs-datepicker'
import {ptBR, en, es, de} from 'vuejs-datepicker/dist/locale'
import VAChart from '../widgets/VAChart'
import {firebaseApp} from '../../helpers/firebaseApp'
import Vue2Filters from 'vue2-filters'
import config from '../../config'

var db = firebaseApp.database()

export default {
  name: 'Relatorios',
  mixins: [Vue2Filters.mixin],
  components: {
    Datepicker,
    'va-chart': VAChart
  },
  firebase: {
    registros: db.ref(config.project)
  },
  mounted () {
  },
  computed: {
    acumuladosGrafico () {
      return this.$store.state.Relatorios.acumulados.grafico
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  data () {
    return {
      ptBR: ptBR,
      en: en,
      es: es,
      de: de,
      idioma: config.idioma,
      registros: [],
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      parametro: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        parametro: '',
        label: ''
      },
      exibirGrafico: false,
      errors: []
    }
  },
  methods: {
    debug (parametro, label) {
      console.log('Debug parametro: ' + parametro)
      console.log('Debug label: ' + label)
    },
    showAlert (titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      // Use sweetalret2
      this.$swal({
        title: titulo,
        text: mensagem,
        type: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      })
    },
    efetuarPesquisa: function () {
      this.exibirGrafico = false
      if ((this.dataInicioBusca === '') || (this.dataFimBusca === '')) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Não pode ter data vazia'
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Data final não pode ser anterior à data inicial'
      } else if (this.parametro === '') {
        this.showDismissibleAlert = true
        this.messageAlert = 'Favor selecionar um parâmetro de pesquisa'
      } else {
        this.showDismissibleAlert = false
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10)
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10)
        this.pesquisa.parametro = this.parametro[0]
        this.pesquisa.label = this.parametro[1] + '(' + this.parametro[2] + ')'
        this.$store.dispatch('createGraficoAcumulados', this.pesquisa)
        .then(response => {
          this.exibirGrafico = true
        })
        .catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
}
</script>

<style>
.datetime-picker input {
  height: 4em !important;
}
</style>



// WEBPACK FOOTER //
// GraficosAcumulados.vue?fe4beb18